import Vue from 'vue'
import Router from 'vue-router'
import i18n from './i18n'
import Api from '@/utils/Api'
import { isToday } from 'date-fns'
// import { msalInstance } from './auth/MsalConfig'

Vue.use(Router)

export const loginClassic = () => import(/* webpackChunkName: 'login-classic' */'./views/LoginClassic.vue')
export const login = () => import(/* webpackChunkName: 'login' */'./views/LoginChooser.vue')
export const loginVerify = () => import(/* webpackChunkName: 'verify-login' */'./views/LoginVerify.vue')
export const registration = () => import(/* webpackChunkName: 'registration' */'./views/Registration.vue')
export const personaldata = () => import(/* webpackChunkName: 'personaldata' */'./views/PersonalData.vue')
export const companydetail = () => import(/* webpackChunkName: 'companydetail' */'./views/CompanyDetail.vue')
export const SuccessRegister = () => import(/* webpackChunkName: 'success-register' */'./views/SuccessRegister.vue')
export const SuccessLogin = () => import(/* webpackChunkName: 'welcome' */'./views/Welcome/SuccessLogin.vue')
export const Instruction = () => import(/* webpackChunkName: 'welcome' */'./views/Welcome/Instruction.vue')
export const SelfAssessment = () => import(/* webpackChunkName: 'self-assessment' */'./views/SelfAssessment.vue')
export const SuccessAssessment = () => import(/* webpackChunkName: 'success-assessment' */'./views/SuccessAssessment.vue')
export const MyAssessment = () => import(/* webpackChunkName: 'my-assessment' */'./views/Assessment/MyAssessment.vue')
export const AllAssessment = () => import(/* webpackChunkName: 'all-assessment' */'./views/Assessment/AllAssessment.vue')
export const UserProfile = () => import(/* webpackChunkName: 'user-profile' */'./views/Profile/UserProfile.vue')
export const UpdateProfile = () => import(/* webpackChunkName: 'update-profile' */'./views/Profile/UpdateProfile.vue')
export const RedirectPage = () => import(/* webpackChunkName: 'redirect-page' */'./views/RedirectPage.vue')
export const EditAssessment = () => import(/* webpackChunkName: 'edit-assessment' */'./views/EditAssessment.vue')
export const Dashboard = () => import(/* webpackChunkName: 'dashboard' */'./views/Dashboard.vue')
export const FdmDashboard = () => import(/* webpackChunkName: 'fdm-dashboard' */'./views/fdm-dashboard/FdmDashboard.vue')
export const UserManagement = () => import(/* webpackChunkName: 'user-management' */'./views/UserManagement.vue')
export const ManageSecurityGroup = () => import(/* webpackChunkName: 'manage-security-group' */'./views/ManageSecurityGroup.vue')
export const ManageMasterData = () => import(/* webpackChunkName: 'manage-master-data' */'./views/ManageMasterData.vue')
export const ManageNotification = () => import(/* webpackChunkName: 'manage-notification' */'./views/ManageNotification.vue')
export const ManageQuestion = () => import(/* webpackChunkName: 'manage-question' */'./views/ManageQuestion.vue')
export const EmailVerified = () => import(/* webpackChunkName: 'email-verified' */'./views/EmailVerified.vue')
export const EmailExpired = () => import(/* webpackChunkName: 'email-expired' */'./views/EmailExpired.vue')
export const PermissionError = () => import(/* webpackChunkName: 'permission-error' */'./views/Error/PermissionError.vue')
export const RouteWrapper = () => import(/* webpackChunkName: 'RouteWrapper' */'./views/RouteWrapper.vue')

function getRouteName (category) {
  switch (category) {
    case 'all_dhm':
      return 'all-assessment'
    case 'my_dhm':
      return 'my-assessment'
    case 'user':
      return 'user-management'
    case 'role':
      return 'manage-security-group'
    case 'master_data':
      return 'manage-master-data'
    case 'notification':
      return 'manage-notification'
    case 'question':
      return 'manage-question'
  }
}

async function redirectIfAuthenticated (to, from, next) {
  localStorage.removeItem('PersonalData')
  localStorage.removeItem('HRISAccount')
  localStorage.removeItem('Registration')

  if (to.name === 'callback-auth') {
    return next()
  }

  if (!localStorage.getItem('token')) {
    return next()
  }

  // modify disini, redirect ke mfa
  const { data } = await Api.users.me()
  localStorage.profile = JSON.stringify(data)

  const profile = data
  let routing = profile.role.permissions
  routing = routing.sort((a, b) => a.level - b.level)
  localStorage.setItem('defaultRoute', JSON.stringify(routing[0]))

  const defaultRouting = routing[0]
  const lastSubmissionDate = profile.lastSubmissionDate

  if (
    (defaultRouting.category === 'my_dhm' ||
      defaultRouting.category === 'all_dhm') &&
    defaultRouting.permissions.includes('add')
  ) {
    if (lastSubmissionDate && isToday(new Date(lastSubmissionDate))) {
      return next(`${to.path}/${getRouteName(defaultRouting.category)}`)
    }
    return next(`${to.path}/verify-login`)
    // return next(`${to.path}/success-login`)
  }
  return next(`${to.path}/${getRouteName(defaultRouting.category)}`)
}

export const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: `/${i18n.locale}`
    },
    {
      path: '/callback-auth',
      name: 'callback-auth',
      component: {
        async created () {
          const response = await this.$msal.handleRedirectPromise()

          if (response) {
            // simpan token Azure (kalau backend perlu)
            localStorage.login = true

            // redirect ke dashboard (pakai locale)
            this.$router.replace(`/${this.$i18n.locale}/dashboard`)
          }
        },
        render: h => h('div', 'Signing you in...')
      }
    },
    {
      path: '/:lang',
      component: RouteWrapper,
      beforeEnter (to, from, next) {
        if (to.name !== 'edit-assessment') {
          localStorage.removeItem('idAssessment')
        }
        next()
      },
      children: [
        {
          path: '/',
          name: 'login',
          component: login,
          beforeEnter: (to, from, next) => {
            // const isClassicLoggedIn = !!localStorage.getItem('token')
            // const isAzureLoggedIn = !!msalInstance.getActiveAccount()

            // if (isClassicLoggedIn || isAzureLoggedIn) {
            //   next({ name: 'dashboard', params: { lang: to.params.lang } })
            // } else {
            next()
            // }
          }
        },
        {
          path: 'login/classic',
          name: 'login-classic',
          component: loginClassic,
          beforeEnter: redirectIfAuthenticated
        },
        {
          path: 'login/verify',
          name: 'verify-login',
          component: loginVerify
        },
        {
          path: 'registration',
          name: 'registration',
          component: registration
        },
        {
          path: 'personaldata',
          name: 'personaldata',
          component: personaldata
        },
        {
          path: 'companydetail',
          name: 'companydetail',
          component: companydetail
        },
        {
          path: 'success-register',
          name: 'success-register',
          component: SuccessRegister
        },
        {
          path: 'success-assessment',
          name: 'success-assessment',
          component: SuccessAssessment,
          props: true,
          meta: {
            auth: true
          }
        },
        {
          path: 'success-login',
          name: 'success-login',
          component: SuccessLogin,
          meta: {
            auth: true
          }
        },
        {
          path: 'instruction',
          name: 'instruction',
          props: true,
          component: Instruction,
          meta: {
            auth: true
          }
        },
        {
          path: 'self-assessment',
          name: 'self-assessment',
          component: SelfAssessment,
          meta: {
            auth: true
          }
        },
        {
          path: 'my-assessment',
          name: 'my_dhm',
          component: MyAssessment,
          props: true,
          meta: {
            auth: true
          }
        },
        {
          path: 'all-assessment',
          name: 'all_dhm',
          component: AllAssessment,
          props: true,
          meta: {
            auth: true
          }
        },
        {
          path: 'user-profile',
          name: 'user-profile',
          component: UserProfile,
          meta: {
            auth: true
          }
        },
        {
          path: 'update-profile',
          name: 'update-profile',
          component: UpdateProfile,
          meta: {
            auth: true
          }
        },
        {
          path: 'redirect-page',
          name: 'redirect-page',
          component: RedirectPage,
          meta: {
            auth: true
          }
        },
        {
          path: 'edit-assessment',
          name: 'edit-assessment',
          props: true,
          component: EditAssessment,
          meta: {
            auth: true
          }
        },
        {
          path: 'dashboard',
          name: 'dashboard',
          component: Dashboard,
          meta: {
            auth: true
          }
        },
        {
          path: 'fdm-dashboard',
          name: 'fdm-dashboard',
          component: FdmDashboard,
          meta: {
            auth: true
          }
        },
        {
          path: 'user-management',
          name: 'user',
          component: UserManagement,
          meta: {
            auth: true
          }
        },
        {
          path: 'manage-security-group',
          name: 'role',
          component: ManageSecurityGroup,
          meta: {
            auth: true
          }
        },
        {
          path: 'manage-master-data',
          name: 'master_data',
          component: ManageMasterData,
          meta: {
            auth: true
          }
        },
        {
          path: 'manage-notification',
          name: 'notification',
          component: ManageNotification,
          meta: {
            auth: true
          }
        },
        {
          path: 'manage-question',
          name: 'question',
          component: ManageQuestion,
          meta: {
            auth: true
          }
        },
        {
          path: 'email-verified',
          component: EmailVerified
        },
        {
          path: 'email-expired',
          component: EmailExpired
        },
        {
          path: 'permission-error',
          component: PermissionError
        }
      ]
    }
  ]
})

export default router
